module.exports = __webpack_public_path__ + "static/media/cr.pictogram.08721ee3.svg";